export default __webpack_public_path__ + "static/underline-20-551cf1134981222a31d2599a239a05cb.svg";